// src/components/ProtectedAdminRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// ※ここでは例として LocalStorage から取得するケースを示しています。
// あるいは React Context で管理している状態を利用してください。
export const ProtectedAdminRoute: React.FC = () => {
  // ログイン済みのユーザー情報を localStorage から取得する
  const user = localStorage.getItem('user');

  // ユーザー情報が存在しない場合は /admin/login にリダイレクトする
  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  // 認証済みの場合は Outlet により子ルートを表示
  return <Outlet />;
};
